export default "__VITE_ASSET__CybsLNfu__"